import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HomePage, AboutPage } from '../pages';

const BASE = '/twentytwentysix';

export function TwentyTwentysixRoutes() {
  return (
    <Routes>
      <Route path={BASE} element={<HomePage />} />
      <Route path={`${BASE}/about`} element={<AboutPage />} />
      <Route path="*" element={<Navigate to={BASE} replace />} />
    </Routes>
  );
}

export default TwentyTwentysixRoutes;
